module.exports = __webpack_public_path__ + "img/airtel.fa1e2d5a.png";